import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';
import { Panel } from 'primereact/panel';
import ArrayUtil from '../../../../../utils/ArrayUtil';
import { AssessmentConstants } from '../../../../../shared/Constants';
import { intlShape } from '../../../../../components/prop-types';

const i18n = defineMessages({
  assessed: {
    id: 'candidate.status.ASSESSED',
    defaultMessage: 'Assessed',
  },
});

const getDoneSurvey = objectives => (ArrayUtil.isNotEmpty(objectives)
  ? objectives.filter(obj => obj.status === AssessmentConstants.ASMT_STATUS.SUBMITTED)
  : []);
const getSurveyStatusHTMLClass = (done = 0, total = 0) => {
  if (done === total) return 'filter filter--success is-active';
  return 'filter filter--warning is-active';
};
class DataDisplay extends Component {
  render() {
    const { survey, intl: { formatMessage } } = this.props;

    const assessedHeader = formatMessage(i18n.assessed);
    const {
      self, peers, others, managers, directReports, template,
    } = survey;
    const doneSelf = self.status === AssessmentConstants.ASMT_STATUS.SUBMITTED ? 1 : 0;
    const donePeers = getDoneSurvey(peers);
    const doneOthers = getDoneSurvey(others);
    const doneManagers = getDoneSurvey(managers);
    const doneDirects = getDoneSurvey(directReports);
    return (
      <div className="p-grid">
        <div className="p-md-6 p-sm-12">
          <Panel header={survey.name}>
            <div className="p-grid">
              <div className="p-md-6 p-sm-12 sentence-capitalized">
                <FormattedMessage id="jobMatch.basedOn" defaultMessage="based on" />
                :
              </div>
              <div className="p-md-6 p-sm-12">
                <strong>{template.title}</strong>
              </div>
            </div>
            <div className="p-grid">
              <div className="p-md-6 p-sm-12 sentence-capitalized">
                <FormattedMessage id="lbl.360.allow_comment" defaultMessage="Allow comments" />
                :
              </div>
              <div className="p-md-6 p-sm-12">
                {survey.commentsEnabled
                  ? (
                    <FormattedMessage id="lbl.yes" defaultMessage="Yes">
                      {text => <strong>{text}</strong>}
                    </FormattedMessage>
                  )
                  : (
                    <FormattedMessage id="lbl.no" defaultMessage="No">
                      {text => <strong>{text}</strong>}
                    </FormattedMessage>
                  )}
              </div>
            </div>
          </Panel>
        </div>
        <div className="p-md-6 p-sm-12">
          <Panel header={assessedHeader}>
            <div className="p-grid">
              <div className="p-md-4 p-sm-12">
                <FormattedMessage id="360.self" defaultMessage="Self" />
                :
              </div>
              <div className="p-md-8 p-sm-12">
                <span className={getSurveyStatusHTMLClass(doneSelf, 1)}>{`${doneSelf} / 1`}</span>
              </div>
            </div>
            <div className="p-grid">
              <div className="p-md-4 p-sm-12">
                <FormattedMessage id="360.managers" defaultMessage="Bosses" />
                :
              </div>
              <div className="p-md-8 p-sm-12">
                <span className={getSurveyStatusHTMLClass(doneManagers.length, managers.length)}>
                  {`${doneManagers.length} / ${managers.length}`}
                </span>
              </div>
            </div>
            <div className="p-grid">
              <div className="p-md-4 p-sm-12">
                <FormattedMessage id="360.peers" defaultMessage="Peers" />
                :
              </div>
              <div className="p-md-8 p-sm-12">
                <span className={getSurveyStatusHTMLClass(donePeers.length, peers.length)}>
                  {`${donePeers.length} / ${peers.length}`}
                </span>
              </div>
            </div>
            <div className="p-grid">
              <div className="p-md-4 p-sm-12">
                <FormattedMessage id="360.directReports" defaultMessage="Direct Reports" />
                :
              </div>
              <div className="p-md-8 p-sm-12">
                <span className={getSurveyStatusHTMLClass(doneDirects.length, directReports.length)}>
                  {`${doneDirects.length} / ${directReports.length}`}
                </span>
              </div>
            </div>
            <div className="p-grid">
              <div className="p-md-4 p-sm-12">
                <FormattedMessage id="360.others" defaultMessage="Others" />
                :
              </div>
              <div className="p-md-8 p-sm-12">
                <span className={getSurveyStatusHTMLClass(doneOthers.length, others.length)}>
                  {`${doneOthers.length} / ${others.length}`}
                </span>
              </div>
            </div>
          </Panel>
        </div>
      </div>
    );
  }
}

DataDisplay.propTypes = {
  survey: PropTypes.objectOf(PropTypes.any).isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(DataDisplay);
